import React, { useRef } from 'react';

import { TrackingScope } from '@zego/tracking';

import ScooterCarQuickEstimates from '@zego/components/promotions/ScooterCarQuickEstimates';

import UberEatsPageWrapper from './partners/UberEatsPageWrapper';
import withPromotionsLayout from './withPromotionsLayout';

import ogImage from '@zego/static/images/social/social-generic.jpg';

function GetOnTheRoadUberEats() {
  const salesLeadSection = useRef(null);

  const scrollToSalesLead = () => {
    if (salesLeadSection.current) {
      salesLeadSection.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  };

  return (
    <UberEatsPageWrapper scrollToSalesLead={scrollToSalesLead}>
      <TrackingScope locationName="Uber Eats Ref">
        <ScooterCarQuickEstimates ref={salesLeadSection} />
      </TrackingScope>
    </UberEatsPageWrapper>
  );
}

export default withPromotionsLayout(GetOnTheRoadUberEats, {
  title: 'Zego & Uber Eats',
  ogImage: ogImage,
});
